import { z } from "zod";
import { AgencyIdSchema } from "../../primitives/ids.js";
export const CustomerApprovalAtomV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.customer-approval-atom.v1.0"),
    approvalId: z.string().regex(/^wdap_[a-zA-Z0-9_-]+$/),
    agencyId: AgencyIdSchema,
    artifactKind: z.enum(["ESTIMATE", "PROPOSAL", "CONTRACT"]),
    artifactId: z.string().min(1),
    documentVersion: z.string().min(1),
    approverIdentity: z
        .object({
        displayName: z.string().min(1),
        email: z.string().email(),
    })
        .strict(),
    consentText: z.string().min(1),
    consented: z.boolean(),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordCustomerApprovalAtom(input) {
    if (!input.consented) {
        throw new Error("approval_requires_consent");
    }
    return CustomerApprovalAtomV1Schema.parse({
        schemaVersion: "clientops.customer-approval-atom.v1.0",
        approvalId: input.approvalId,
        agencyId: input.agencyId,
        artifactKind: input.artifactKind,
        artifactId: input.artifactId,
        documentVersion: input.documentVersion,
        approverIdentity: input.approverIdentity,
        consentText: input.consentText,
        consented: true,
        recordedAt: input.recordedAt ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=approval-atom.js.map